import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  Stack,
  Alert,
  AlertTitle,
} from "@mui/material";
import { Form, Field, FormSpy } from "react-final-form";
import TextInput from "../reusableComponents/components/generics/TextInput";
import RegionPicker from "../pickers/RegionPicker";
import DistrictPicker from "../pickers/DistrictPicker";
import ContributionPlanBundlePicker from "../pickers/ContributionPlanBundlePicker";
import MunicipalityPicker from "../pickers/MunicipalityPicker";
import LocationPicker from "../pickers/LocationPicker";
import VillagePicker from "../pickers/VillagePicker";
import { useTranslation } from "react-i18next";
import Dropdown from "../reusableComponents/components/generics/Dropdown";
import { bankOptions } from "../utils/constant";
import { useForm } from "react-final-form";
import { styled } from "@mui/system";
import CalendarPicker from "../pickers/CalenderPicker";
import { formatDateFromISO } from "../utils/helper";
import SingleRegionPicker from "../pickers/SingleRegionPicker";

// const useStyles = makeStyles((theme) => ({
//   paperHeader: { ...theme.paper.header, fontSize: 600, padding: ".8rem" },
//   paper: { ...theme.paper.paper },
//   inputContainer: { padding: "1rem" },
// }));
const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginLeft: "auto",
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "1rem",
}));

const StyledAlert = styled(Stack)(({ }) => ({
  marginTop: "2rem",
}));

const StyledAlertTitle = styled(AlertTitle)(({ }) => ({
  fontWeight: "bold",
  color: "red",
}));

function PolicyholderForm({ values, policyholderUserData, setFormvalue }) {
  // const classes = useStyles();
  const [formValues, setFormValues] = useState();
  const { t } = useTranslation();
  const form = useForm();
  const legalFormVal = [
    {
      value: "1",
      label: t("legalAssoc"),
    },
    {
      value: "2",
      label: t("legalSASAU"),
    },
    {
      value: "3",
      label: t("legalConfession"),
    },
    {
      value: "4",
      label: t("legalCollectivité"),
    },
    {
      value: "5",
      label: t("legalCoopérative"),
    },
    {
      value: "6",
      label: t("legalÉtablissement"),
    },
    {
      value: "7",
      label: t("legalÉtablissementPublic"),
    },
    {
      value: "8",
      label: t("legalFondation"),
    },
    {
      value: "9",
      label: t("legalOrganisation"),
    },
    {
      value: "10",
      label: t("legalSARLU"),
    },
    {
      value: "11",
      label: t("legalAutre"),
    },
  ];
  const ActivityCode = [
    {
      value: "1",
      label: t("activityAgriculture"),
      code: "AEP",
    },
    {
      value: "2",
      label: t("activityBanques"),
      code: "BAM",
    },
    {
      value: "3",
      label: t("activityBâtiment"),
      code: "BTP",
    },
    {
      value: "4",
      label: t("activityCommerces"),
      code: "COM",
    },
    {
      value: "5",
      label: t("activityEnvironnement"),
      code: "ENV",
    },
    {
      value: "6",
      label: t("activityExploitation"),
      code: "EXF",
    },
    {
      value: "7",
      label: t("activityHôtelleries"),
      code: "HER",
    },
    {
      value: "8",
      label: t("activityIndustries"),
      code: "IND",
    },
    {
      value: "9",
      label: t("activityJeux"),
      code: "JEL",
    },
    {
      value: "10",
      label: t("activityMines"),
      code: "MIS",
    },
    {
      value: "11",
      label: t("activityPétrole"),
      code: "PET",
    },
    {
      value: "12",
      label: t("activityParapétrolier"),
      code: "PPT",
    },
    {
      value: "13",
      label: t("activityProjet"),
      code: "PRJ",
    },
    {
      value: "14",
      label: t("activitySanté"),
      code: "SEM",
    },
    {
      value: "15",
      label: t("activityServices"),
      code: "SER",
    },
    {
      value: "16",
      label: t("activityTransport"),
      code: "TEL",
    },
    {
      value: "17",
      label: t("activityTélécom"),
      code: "TEN",
    },
    {
      value: "18",
      label: t("activityAutre"),
      code: "AUT",
    },
  ];
  return (
    <Box>
      {!!policyholderUserData?.isRework && (
        <StyledAlert>
          <Alert
            severity="error"
            sx={{
              border: "1px solid red",
              backgroundColor: "#ffe6e6", // light red background
              color: "red",
            }}
          >
            <StyledAlertTitle>
              Application is reverted with the following reason. Kindly provide
              required information and re-submit the application.
            </StyledAlertTitle>
            <Typography>
              Reason: {policyholderUserData?.reworkOption}
            </Typography>
            <Typography>
              Comment by CAMU: {policyholderUserData?.reworkComment}
            </Typography>
          </Alert>
        </StyledAlert>
      )}
      <FormSpy subscription={{ values: true, errors: true }}>
        {({ values, errors }) => {
          return (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <StyledPaper>
                    <StyledPaperHeader
                      container
                      alignItems="center"
                      direction="row"
                    >
                      <Grid item alignItems="center">
                        <Typography variant="h6">
                          {t("General Information")}
                        </Typography>
                      </Grid>
                    </StyledPaperHeader>

                    <StyledGrid container alignItems="center" direction="row">
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="tradeName"
                          component={TextInput}
                          label={t("Trade Name")}
                          type="text"
                          required={true}
                          error={errors.tradeName}
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="mainActivity"
                          component={TextInput}
                          label={t("Main Activity")}
                          type="text"
                          error={errors.mainActivity}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="contactName"
                          component={TextInput}
                          label={t("Contact Name")}
                          type="text"
                          error={errors.contactName}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="shortName"
                          component={TextInput}
                          label={t("Short Name")}
                          type="text"
                          error={errors.shortName}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="niu"
                          component={TextInput}
                          label={t("NIU")}
                          type="text"
                          error={errors.niu}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="rccm"
                          component={TextInput}
                          label={t("No. RCCM")}
                          type="text"
                          error={errors.rccm}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="dateValidFrom"
                          component={CalendarPicker}
                          onChange={(value) =>
                            form.change("dateValidFrom", value)
                          }
                          label={t("Created Date")}
                          type="text"
                          inputVal={formatDateFromISO(
                            policyholderUserData?.dateValidFrom
                          )}
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="createdAt"
                          component={SingleRegionPicker}
                          label={t("Created At")}
                          required={values.rccm !== "" ? true : false}
                          error={errors.createdAt}
                        />
                      </Grid>

                      <Grid item xs={3} className="common-input">
                        <Field
                          name="nbEmployees"
                          component={TextInput}
                          label={t("No. of Employees")}
                          type="text"
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="region"
                          component={RegionPicker}
                          label={t("Department")}
                          error={errors.region}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="city"
                          component={DistrictPicker}
                          label={t("City")}
                          region={values}
                          error={errors.city}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="municipality"
                          component={MunicipalityPicker}
                          label={t("Municipality")}
                          district={values}
                          error={errors.municipality}
                          required
                        />
                      </Grid>

                      <Grid item xs={3} className="common-input">
                        <Field
                          name="village"
                          component={VillagePicker}
                          label={t("Village")}
                          municipality={values}
                          error={errors.village}
                          required
                        />
                      </Grid>
                      
                      <Grid item xs={6} className="common-input">
                        <Field
                          name="address"
                          component={TextInput}
                          label={t("Address")}
                          type="text"
                          error={errors.address}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="phone"
                          component={TextInput}
                          label={t("Phone")}
                          type="text"
                          error={errors.phone}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="email"
                          component={TextInput}
                          label={t("Email")}
                          type="email"
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="legalForm"
                          component={Dropdown}
                          label={t("Legal Form")}
                          options={legalFormVal}
                          error={errors.legalForm}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="activityCode"
                          component={Dropdown}
                          label={t("Activity Code")}
                          options={ActivityCode}
                          error={errors.activityCode}
                          required
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="contributionPlanBundle"
                          component={ContributionPlanBundlePicker}
                          label={t("Contribution Plan Bundle")}
                          error={errors.contributionPlanBundle}
                          required
                        />
                      </Grid>
                    </StyledGrid>
                    {/* </Grid> */}
                    {/* </Paper> */}
                  </StyledPaper>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  {/* <Paper className={classes.paper}>
                   */}
                  <StyledPaper>
                    {/* <Grid
              container
              alignItems="center"
              direction="row"
              className={classes.paperHeader}
            > */}
                    <StyledPaperHeader
                      container
                      alignItems="center"
                      direction="row"
                    >
                      <Grid item alignItems="center">
                        <Typography variant="h6">
                          {t("Bank Details")}
                        </Typography>
                      </Grid>
                    </StyledPaperHeader>
                    {/* <Grid
              container
              alignItems="center"
              direction="row"
              className={classes.inputContainer}
            > */}
                    <StyledGrid container alignItems="center" direction="row">
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="bank"
                          component={Dropdown}
                          label={t("Bank Name")}
                          options={bankOptions}
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <TextInput
                          name="bankCode"
                          label={t("Bank Code")}
                          type="text"
                          value={values.bank}
                          disabled
                        />
                        {/* <Field
                          name="bankCode"
                          component={TextInput}
                          label="Bank Code"
                          type="text"
                        /> */}
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="lockerCode"
                          component={TextInput}
                          label={t("Bank Locker Code")}
                          type="text"
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Field
                          name="accountNb"
                          component={TextInput}
                          label={t("Bank Account No")}
                          type="text"
                        />
                      </Grid>
                      <Grid item xs={3} className="common-input no-arrow">
                        <Field
                          name="bankKey"
                          component={TextInput}
                          label={t("RIB Key")}
                          type="number"
                          error={errors.bankKey}
                        />
                      </Grid>
                      {/* <Grid item xs={3} className="common-input">
                <Field
                  name="rib"
                  component={TextInput}
                  label="RIB Key"
                  type="text"
                />
              </Grid> */}
                    </StyledGrid>
                    {/* </Grid> */}
                  </StyledPaper>
                  {/* </Paper> */}
                </Grid>
              </Grid>
            </>
          );
        }}
      </FormSpy>
      {/* </form>
        )}
      /> */}
    </Box>
  );
}

export default PolicyholderForm;
